import React, { useCallback, useState }from 'react';

import T, { Translate } from '../../../i18n/i18n';
import Checkbox from "../../../Forms/Checkbox/Checkbox";
import TimeSelector from "../../../Forms/TimeSelector/TimeSelector";
import TagSelector from "../../../Forms/TagSelector/TagSelector";
import * as Tag from './FormFilterstyles';

export default ({opened, onClose, onFilter}) => {

    const [formName, setFormName] = useState('');
    const [formFrequency, setFormFrequency] = useState('any');
    const [formPositions, setFormPositions] = useState('any');
    const [formCalendar, setFormCalendar] = useState('auto');
    const [formDays, setFormDays] = useState(0);
    const [formTimeFrom, setFormTimeFrom] = useState('00:00');
    const [formTimeTo, setFormTimeTo] = useState('23:59');
    const [formTagContent, setFormTagContent] = useState([]);
    const [formTagContentAvoid, setFormTagContentAvoid] = useState([]);
    const [formTagTools, setFormTagTools] = useState([]);
    const [formTagSystems, setFormTagSystems] = useState([]);

    const handleClose = () => {
        if (onClose && typeof onClose === 'function') {
            onClose();
        }
    }

    const handleClearForm = () => {
        setFormName('');
        setFormFrequency('any');
        setFormPositions('any');
        setFormCalendar('auto');
        setFormDays(0);
        setFormTimeFrom('00:00');
        setFormTimeTo('23:59');
        setFormTagContent([]);
        setFormTagContentAvoid([]);
        setFormTagTools([]);
        setFormTagSystems([]);

        if (typeof onFilter === 'function') {
            onFilter({});
        }

        handleClose();
    }

    const handleSubmit = () => {
        let filter = {
            name: formName,
            frequency: formFrequency,
            positions: formPositions,
            calendar: formCalendar,
            days: formDays,
            timeFrom: formTimeFrom,
            timeTo: formTimeTo,
            tagContent: formTagContent,
            tagContentAvoid: formTagContentAvoid,
            tagTools: formTagTools,
            tagSystems: formTagSystems,
        };

        if (typeof onFilter === 'function') {
            onFilter(filter);
        }

        handleClose();
    }

    const handleChangeSystem = useCallback((value) => {
        setFormTagSystems(value);
    }, []);

    const handleChangeTools = useCallback((value) => {
        setFormTagTools(value);
    }, []);

    const handleChangeContent = useCallback((value) => {
        setFormTagContent(value);
    }, []);

    const handleChangeContentAvoid = useCallback((value) => {
        setFormTagContentAvoid(value);
    }, []);


    return <>
        <Tag.Background 
            className={opened ? 'opened' : ''}
            onClick={handleClose}
        />
        <Tag.Window 
            className={opened ? 'opened' : ''} 
        >
            <Tag.WindowTitle><T value="filter.title" /></Tag.WindowTitle>
            
            <Tag.WindowContent>
                <Tag.ColumnGeneral>
                    
                    <Tag.Label><T value="filter.name" /></Tag.Label>
                    <Tag.Input value={formName} onChange={(e)=>{setFormName(e.target.value)}} />
                    
                    <Tag.Label><T value="filter.frequency" /></Tag.Label>
                    <Tag.Select value={formFrequency} onChange={(e)=>{setFormFrequency(e.target.value)}}>
                        <option value="any">{Translate("filter.frequency-any")}</option>
                        <option value="weekly">{Translate("filter.frequency-weekly")}</option>
                        <option value="fortnight">{Translate("filter.frequency-fortnight")}</option>
                        <option value="monthly">{Translate("filter.frequency-monthly")}</option>
                        <option value="oneshot">{Translate("filter.frequency-oneshot")}</option>
                    </Tag.Select>
                    
                    {/*<Tag.Label><T value="filter.positions" /></Tag.Label>
                    <Tag.Select value={formPositions} onChange={(e)=>{setFormPositions(e.target.value)}}>
                        <option value="any">{Translate("filter.positions-any")}</option>
                        <option value="gm">{Translate("filter.positions-gm")}</option>
                        <option value="player">{Translate("filter.positions-player")}</option>
                    </Tag.Select>*/}

                    <Tag.Divisor>
                        <T value="filter.availability" />
                    </Tag.Divisor>

                    <Tag.Label><T value="filter.calendar" /></Tag.Label>
                    <Tag.Select value={formCalendar} onChange={(e)=>{setFormCalendar(e.target.value)}}>
                        <option value="auto">{Translate("filter.calendar-auto")}</option>
                        <option value="manual">{Translate("filter.calendar-manual")}</option>
                        <option value="none">{Translate("filter.calendar-none")}</option>
                    </Tag.Select>

                    { formCalendar === 'auto' ? <Tag.Row>
                        <Tag.Subtitle><T value="filter.calendar-subtitle" /></Tag.Subtitle>
                    </Tag.Row> : null }
                    { formCalendar === 'manual' ? <>
                        <Tag.Label><T value="filter.days" /></Tag.Label>
                        <Tag.Row>
                            <Tag.Column>
                                <Tag.Label className='small'>
                                    <T value="date-d.0" />
                                </Tag.Label>
                                <Checkbox className={'small'} value={formDays & 1} onClick={(v) => {setFormDays(s => (v ? s|1 : s&~1))}} justify="center"/></Tag.Column>
                            <Tag.Column>
                                <Tag.Label className='small'>
                                    <T value="date-d.1" />
                                </Tag.Label>
                                <Checkbox className={'small'} value={formDays & 2} onClick={(v) => {setFormDays(s => (v ? s|2 : s&~2))}} justify="center"/></Tag.Column>
                            <Tag.Column>
                                <Tag.Label className='small'>
                                    <T value="date-d.2" />
                                </Tag.Label>
                                <Checkbox className={'small'} value={formDays & 4} onClick={(v) => {setFormDays(s => (v ? s|4 : s&~4))}} justify="center"/></Tag.Column>
                            <Tag.Column>
                                <Tag.Label className='small'>
                                    <T value="date-d.3" />
                                </Tag.Label>
                                <Checkbox className={'small'} value={formDays & 8} onClick={(v) => {setFormDays(s => (v ? s|8 : s&~8))}} justify="center"/></Tag.Column>
                            <Tag.Column>
                                <Tag.Label className='small'>
                                    <T value="date-d.4" />
                                </Tag.Label>
                                <Checkbox className={'small'} value={formDays & 16} onClick={(v) => {setFormDays(s => (v ? s|16 : s&~16))}} justify="center"/></Tag.Column>
                            <Tag.Column>
                                <Tag.Label className='small'>
                                    <T value="date-d.5" />
                                </Tag.Label>
                                <Checkbox className={'small'} value={formDays & 32} onClick={(v) => {setFormDays(s => (v ? s|32 : s&~32))}} justify="center"/></Tag.Column>
                            <Tag.Column>
                                <Tag.Label className='small'>
                                    <T value="date-d.6" />
                                </Tag.Label>
                                <Checkbox className={'small'} value={formDays & 64} onClick={(v) => {setFormDays(s => (v ? s|64 : s&~64))}} justify="center"/></Tag.Column>
                        </Tag.Row>
                        <Tag.Label><T value="filter.times" /></Tag.Label>
                        <Tag.Row justify="space-between" marginBottom={0}>
                            <Tag.Label className='timer small'><T value="filter.times-from" /></Tag.Label>
                            <TimeSelector value={formTimeFrom} onChange={(v)=>{setFormTimeFrom(v)}} />
                            <Tag.Label className='timer small'><T value="filter.times-to" /></Tag.Label>
                            <TimeSelector value={formTimeTo} onChange={(v)=>{setFormTimeTo(v)}} />
                        </Tag.Row>
                    </> : null }
                </Tag.ColumnGeneral>

                <Tag.ColumnContent>
                    <Tag.Row>
                        <TagSelector 
                            includedColor="#26f" 
                            tagGroup="gamesystems" 
                            canExclude={false}
                            hideSubtitles={true} 
                            tagService="system" 
                            onChange={handleChangeSystem}
                            value={formTagSystems}
                        />
                        <TagSelector 
                            includedColor="#cc0" 
                            tagGroup="tools" 
                            canExclude={false} 
                            hideSubtitles={true} 
                            tagService="tools" 
                            onChange={handleChangeTools}
                            value={formTagTools}
                        />
                    </Tag.Row>
                    <TagSelector 
                        includedColor="#0c0" 
                        avoidedColor="#f22" 
                        tagGroup="contentFilter" 
                        canExclude={true} 
                        tagService="content" 
                        onChange={handleChangeContent}
                        value={formTagContent}
                        onChangeAvoid={handleChangeContentAvoid}
                        valueAvoid={formTagContentAvoid}
                    />
                </Tag.ColumnContent>
            </Tag.WindowContent>
            <Tag.ButtonsBar>
                <Tag.Button color="#888" onClick={handleClose}><T value="cancel" /></Tag.Button>
                <Tag.Button color="#888" onClick={handleClearForm}><T value="filter.clearButton" /></Tag.Button>
                <Tag.Button color="#26f" onClick={handleSubmit}><T value="filter.filterButton" /></Tag.Button>
            </Tag.ButtonsBar>
        </Tag.Window>
    </>
};